import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../../../utils/PropTypesDefinitions'
import SmallBodyFont from '../../../../Theme/Fonts/SmallBody'
import CompetitorImage from '../../../../BaseComponents/Image/Flag'

type SetCompetitorProps = {
    name: string
    imageUrl?: string
    imageAlt?: string
    bold?: boolean
    paddingBottom?: number
    hideImage?: boolean
} & TestID

const SetCompetitor: FunctionComponent<SetCompetitorProps> = ({
    name,
    imageUrl,
    imageAlt,
    bold,
    paddingBottom,
    hideImage,
    testID,
}) => {
    return (
        <Grid testID={testID} horizontal paddingRight={2} paddingBottom={paddingBottom}>
            {!hideImage ? (
                <Grid noExpand marginRight={3} center minWidth={20}>
                    <CompetitorImage imageUrl={imageUrl} alt={imageAlt} width={20} size="S" />
                </Grid>
            ) : null}
            <Grid noExpand minWidth={0}>
                <SmallBodyFont bold={bold} numberOfLines={1}>
                    {name}
                </SmallBodyFont>
            </Grid>
        </Grid>
    )
}
export default SetCompetitor
